// src/App.jsx
import React from "react";
import { MsalProvider } from "@azure/msal-react";
import AppMenuBar from "./appBar/appBar";
import AppRoutes from "./routes/AppRoutes";

function App({ msalInstance }) {
  return (
    <MsalProvider instance={msalInstance}>
      <div>
        <AppMenuBar />
        <AppRoutes />
      </div>
    </MsalProvider>
  );
}

export default App;